<form (ngSubmit)="save()" #formContactSetup="ngForm">
    <div class="card-body mt-0 pt-3 px-3 pb-0 my-0">
            <div class="table-responsive py-0 my-0">
                <table class="table table-sm table-borderless my-0" style="max-width:950px;">
                    <thead class="thead-light">
                        <tr>
                            <th></th>
                            <th>Referring Doctor</th>
                            <th>Referring Hospital</th>
                            <th style="max-width:80px;">Referral Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style="vertical-align: middle;"><b>REFERRED BY</b></td>
                            <td>
                                <input type="text" class="form-control form-control-sm " name="_by_refer_doctor" required
                                autocomplete="off" [(ngModel)]="petService.pet_fullrefer.by_refer_doctor">
                            </td>
                            <td>
                                <input type="text" class="form-control form-control-sm " name="_by_refer_hospital"
                                required autocomplete="off" [(ngModel)]="petService.pet_fullrefer.by_refer_hospital">
                            </td>
                            <td>
                                <input type="date" class="form-control form-control-sm " name="_by_refer_date" required
                                autocomplete="off" [(ngModel)]="petService.pet_fullrefer.by_refer_date">
                            </td>
                        </tr>
                        <tr>
                            <td style="vertical-align: middle;"><b>REFERRED TO</b></td>
                            <td>
                                <input type="text" class="form-control form-control-sm " name="_to_refer_doctor" required
                                autocomplete="off" [(ngModel)]="petService.pet_fullrefer.to_refer_doctor">
                            </td>
                         
                            <td>
                              <input type="text" class="form-control form-control-sm " name="_to_refer_hospital"
                               required autocomplete="off" [(ngModel)]="petService.pet_fullrefer.to_refer_hospital">        
                            </td>
                            <td>
                                <input type="date" class="form-control form-control-sm " name="_to_refer_date" required
                        autocomplete="off" [(ngModel)]="petService.pet_fullrefer.to_refer_date">
                            </td>
                            <td class=text-center>
                                <button type="submit" class="btn btn-primary btn-sm">
                                    <i class="fas fa-save icon-sm"></i> Save Changes
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </div>
        <hr>

        <div class="card-body mt-0 pt-0 px-3 pb-0 my-0">
            <h6 class="mb-2">Referral History</h6>
            <div class="table-responsive py-0 my-0">
                <table class="table table-sm table-hover my-0">
                    <thead class="thead-light">
                        <tr>
                            <th>Date Added</th>
                            <th>Referred By - Doctor</th>
                            <th>Referred By - Hospital</th>
                            <th>Referral Date</th>
                            <th>Referred To - Doctor</th>
                            <th>Referred To - Hospital</th>
                            <th>Referral Date</th>
                            <th>Added By</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of petService.pet_refer_hist">
                            <td>{{ item.date_added | date:'MM/dd/yyyy h:mm a' }}</td>
                            <td>{{ item.by_refer_doctor }}</td>
                            <td>{{ item.by_refer_hospital }}</td>
                            <td>{{ item.by_refer_date | date:'MM/dd/yyyy' }}</td>
                            <td>{{ item.to_refer_doctor }}</td>
                            <td>{{ item.to_refer_hospital }}</td>
                            <td>{{ item.to_refer_date | date:'MM/dd/yyyy' }}</td>
                            <td>{{ item.done_by }}</td>
                        </tr>
                        <tr *ngIf="petService.pet_refer_hist.length === 0">
                            <td colspan="8" class="text-center text-muted">No referral history yet</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

</form>